export default {"src":"/_next/static/media/amountcoupon.ac34eddd.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};